module.exports = "/build/admin/images/apple-touch-icon-60x60.2368ce7f.png";